import { render, staticRenderFns } from "./CoordinateConfirmDialog.vue?vue&type=template&id=1a00f009&"
import script from "./CoordinateConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./CoordinateConfirmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports